import { commonEn } from './ns/common';
import { enumEn } from './ns/enum';
import { cashierEn } from './ns/cashier';
import { healthEn } from './ns/health';
import { tableEn } from './ns/table';
import { guestCallEn } from './ns/guest-call';
import { kdsEn, queueEn } from './ns/kds';
import { waiterEn } from './ns/waiter';
import { sessionEn } from './ns/session';

import type { id } from './id';

/** ⚠️ Bertipe `typeof id` ⇒ bentuk kunci dipaksa identik SAAT KOMPILASI, bukan saat gerbang jalan. */
export const en: typeof id = {
  common: commonEn,
  enum: enumEn,
  cashier: cashierEn,
  health: healthEn,
  table: tableEn,
  guestCall: guestCallEn,
  kds: kdsEn,
  waiter: waiterEn,
  queue: queueEn,
  session: sessionEn,
};
